module.exports = __webpack_public_path__ + "9fe4d6b75d40228a802475e855522ad0.svg";